import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import { loginActions, useStore } from '@modules';

import { Button } from '@components/Button';
import Restriction from '@components/Restriction';
import SupportLink from '@components/SupportLink';

import UserExistsImage from './user_exists.svg';

import style from './UserExists.scss';

const cn = bemCssModules(style, 'UserExists');

export const UserExists: CustomFC = ({ className }) => {
  const [, dispatch] = useStore();
  const { t } = useTranslation();

  const handleClick = () => dispatch(loginActions.logout());

  const subtitle = (
    <Trans i18nKey="public.account_exist_descr">
      text
      <SupportLink href="mailto:info@mercuryo.io?subject=User exists" />
    </Trans>
  );

  return (
    <Restriction
      className={cn(null, [className])}
      title={t('public.account_exist')}
      subtitle={subtitle}
      images={[<UserExistsImage />, '/img/space_suit_user_blocked.png']}
      button={<Button onClick={handleClick}>{t('public.account_exist_button')}</Button>}
      onLogoClick={handleClick}
      isBlockedPage
    />
  );
};

export default UserExists;
